import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import styles from './index.module.less'

interface OrganizationResult {
	resultClicked(): void
	name: string
	path: string
}

const Result: FC<OrganizationResult> = ({ name, path, resultClicked }) => {
	return (
		<Link className={styles.result} to={path} onClick={resultClicked}>
			{name}
		</Link>
	)
}

export default Result
